import { useTranslation } from 'react-i18next'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const GetQuote = () => {
    const { t } = useTranslation() 

    const form = useRef()
    const sendEmail = (e) => {
        e.preventDefault()
        const sendButton = document.getElementById('sendButton')
        sendButton.innerHTML = 'Sending...'
        sendButton.style.fontSize = '1.2rem'
        emailjs.sendForm('service_6u4ljhg', 'template_a46xb66', form.current, 'g5TX7imVVLB2Hsy8y')
            .then(() => {
                sendButton.style.fontSize = '1.5rem'
                sendButton.innerHTML = 'Send message'
                toast.success('¡Success! you will recieve a response in no time', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '🚀'
                })
                e.target.reset()
                const checkbox = document.getElementsByClassName("checkboxOptions")
                for (let i = 0; i < checkbox.length; i++) {
                    checkbox[i].checked = false
                }
            }, (error) => {
                console.log(error.text)
                sendButton.style.fontSize = '1.5rem'
                sendButton.innerHTML = 'Send message'
                toast.error('Error, please try again ', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '❌'
                })
            })
    }

    let servicios = ""
    const actualizarServicios = (e) => {
        if (e.target.checked) {
            servicios += e.target.value.toUpperCase() + " | "
            document.getElementById("user_services").value = servicios
        } else {
            servicios = servicios.replace(e.target.value.toUpperCase() + " | ", "")
            document.getElementById("user_services").value = servicios
        }
    }

    return (
            <div>
                <div className="px-10">
                    <p className="h1-macro pt-14 mb-4 flex-col no-selection">{ t('quote_title') }</p>
                    
                    <p className="font-semibold text-lg md:text-xl lg:text-2xl xl:text-2xl mt-10">{ t('quote_tag') }</p>

                    <div className="flex flex-wrap gap-x-2 gap-y-4 items-center mt-10 no-selection">
                        <section className="flex">
                            <input className="checkboxOptions border-2 border-gray-300 p-2 hidden" type="checkbox" id="web" name="web" value="web" onChange={actualizarServicios} />
                            <label htmlFor="web" className="labelCheckbox px-2 text-sm grow">{ t('quote_item1') }</label>
                        </section>
                        <section className="flex">
                            <input className="checkboxOptions border-2 border-gray-300 p-2 hidden" type="checkbox" id="ecommerce" name="ecommerce" value="ecommerce" onChange={actualizarServicios} />
                            <label htmlFor="ecommerce" className="labelCheckbox px-2 text-sm grow">{ t('quote_item2') }</label>
                        </section>
                        <section className="flex">
                            <input className="checkboxOptions border-2 border-gray-300 p-2 hidden" type="checkbox" id="stock" name="stock" value="stock" onChange={actualizarServicios} />
                            <label htmlFor="stock" className="labelCheckbox px-2 text-sm grow">{ t('quote_item3') }</label>
                        </section>
                        <section className="flex">
                            <input className="checkboxOptions border-2 border-gray-300 p-2 hidden" type="checkbox" id="logo" name="logo" value="logo" onChange={actualizarServicios} />
                            <label htmlFor="logo" className="labelCheckbox px-2 text-sm grow">{ t('quote_item4') }</label>
                        </section>
                        {/* <section className="flex">
                            <input className="checkboxOptions border-2 border-gray-300 p-2 hidden" type="checkbox" id="seo" name="seo" value="seo" onChange={actualizarServicios} />
                            <label htmlFor="seo" className="labelCheckbox px-2 text-sm grow">SEO</label>
                        </section> */}
                    </div>
                </div>
                    
                <div className="px-10">
                    <form className="mt-11 mx-auto w-full" ref={form} onSubmit={sendEmail}>
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_name') } <span className='text-red-500 select-none'>*</span></h3>
                        <input className="w-full bg-default mb-10 h-10 px-3 text-xl border-2 border-gray-300 focus:border-indigo-500 rounded-md focus:outline-none" type="text" id="user_name" name="user_name" maxLength="40" required />
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_email') } <span className='text-red-500 select-none'>*</span></h3>
                        <input className="w-full bg-default mb-10 h-10 px-3 text-xl border-2 border-gray-300 focus:border-indigo-500 rounded-md" type="email" id="user_email" name="user_email" maxLength="40" required />
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_phone') }</h3>
                        <input className="w-full bg-default mb-10 h-10 px-3 text-xl border-2 border-gray-300 focus:border-indigo-500 rounded-md" type="tel" id="user_phone" name="user_phone" maxLength="40" />
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_message') } <span className='text-red-500 select-none'>*</span></h3>
                        <textarea className="w-full bg-default mb-6 h-64 px-3 text-xl py-3 resize-none border-2 border-gray-300 focus:border-indigo-500 rounded-md" id='message' name="message" required></textarea><br />
                        <input className="hidden" type="text" id="user_services" name="user_services" />
                        <button id='sendButton' className='sendButton rounded-md text-xl bg-accent text-white px-8 py-3 mb-10 grow'>{ t('contact_form_button') }</button>
                    </form>
                    <div className="flex justify-between items-center">
                        {/* <div className="my-10">
                            <Button call={'Send message'} link={'/'}/>
                        </div> */}
    
                        <p className="text-2xl">{ t('contact_form_alttext') } <span className="text-accent">binarybrains.dev@gmail.com</span></p>
                    </div>
                </div>
            </div>
    )
}

export default GetQuote